// Auto-generated Supabase Storage image URLs
// All images are served from the 'product-images' public bucket
import homePageImage from "./images/Home-Page-Image.png";
import ethnicWearImage1 from "./images/Ethnic-Wear-1.png";
import ethnicWearImage2 from "./images/Ethnic-Wear-2.png";
import ethnicWearImage3 from "./images/Ethnic-Wear-3.png";
import ethnicWearImage4 from "./images/Ethnic-Wear-4.png";
import featuredEditsImage1 from "./images/Featured-Edits-Image-1.png";
import featuredEditsImage2 from "./images/Featured-Edits-Image-2.png";
import shopTheLookImage from "./images/ShopTheLook-Image.png";

const BASE =
  "https://kbxmhcysmrjpwaegnuof.supabase.co/storage/v1/object/public/product-images";

export const IMG_50_LESS_CO2_EM = `${BASE}/50-less-CO2-em.jpeg`;
export const IMG_CASUAL_CHIC = `${BASE}/Casual%20Chic%20with%20DAINA%20T-shirt.png`;
export const IMG_60_LESS_ENERGY = `${BASE}/60-less-energy.jpeg`;
export const IMG_90_LESS_WATER = `${BASE}/90-less-water.jpeg`;
export const IMG_BEIGE_HOODIE_1 = `${BASE}/Beige-Hoodie-1.png`;
export const IMG_BEIGE_HOODIE_2 = `${BASE}/Beige-Hoodie-2.png`;
export const IMG_DAINA_FINAL = `${BASE}/DAINA-FINAL.jpeg`;
export const IMG_DAINA_HOODIE_BACK_BALI = `${BASE}/DAINA-Hoodie-Back-Bali.png`;
export const IMG_DAINA_HOODIE_BACK_BANGKOK = `${BASE}/DAINA-Hoodie-Back-Bangkok.png`;
export const IMG_DAINA_HOODIE_BACK_CANADA = `${BASE}/DAINA-Hoodie-Back-Canada.png`;
export const IMG_DAINA_HOODIE_BLACK_2 = `${BASE}/DAINA-Hoodie-Black-2.png`;
export const IMG_DAINA_HOODIE_BLACK_3 = `${BASE}/DAINA-Hoodie-Black-3.jpeg`;
export const IMG_DAINA_HOODIE_HANG = `${BASE}/DAINA-Hoodie-Hang.png`;
export const IMG_DAINA_HOODIE_PINK_GIRL = `${BASE}/DAINA-Hoodie-Pink-Girl.png`;
export const IMG_DAINA_HOODIE_PINK_OLD_LADY = `${BASE}/DAINA-Hoodie-Pink-Old-Lady.png`;
export const IMG_DAINA_HOODIE_SMALL_LOGO = `${BASE}/DAINA-Hoodie-Small-Logo.png`;
export const IMG_DAINA_HOODIE_WHITE_2 = `${BASE}/DAINA-Hoodie-White-2.png`;
export const IMG_DAINA_MAIN_IMAGE = `${BASE}/DAINA-Main-Image.png`;
export const IMG_DAINA_PINK_HOODIE_NEW = `${BASE}/DAINA-Pink-Hoodie-New.png`;
export const IMG_DAINA_WALLPAPER_HOODIE = `${BASE}/DAINA-Wallpaper-Hoodie.png`;
export const IMG_DAINA_WALLPAPER = `${BASE}/DAINA-Wallpaper.jpeg`;
export const IMG_DAINA_BLACK_WHITE = `${BASE}/Daina-Black-White.png`;
export const IMG_DAINA_HOODIE_SMALL_LOGO_2 = `${BASE}/Daina-Hoodie-Small-Logo-2.png`;
export const IMG_DAINA_IMG = `${BASE}/Daina-IMG.jpeg`;
export const IMG_DAINA_IMG1 = `${BASE}/Daina-IMG1.jpeg`;
export const IMG_DAINA_IMG2 = `${BASE}/Daina-IMG2.jpeg`;
export const IMG_DAINA_IMG3 = `${BASE}/Daina-IMG3.jpg`;
export const IMG_DAINA_LOGO_NEW = `${BASE}/Daina-og.png`;
export const IMG_DAINA_SMALL_LOGO_NEW = `${BASE}/Daina-Small-Logo-New.png`;
export const IMG_DAINA_STORE = `${BASE}/Daina-Store.png`;
export const IMG_DAINA_TONAL_CREAM = `${BASE}/Daina-Tonal-Cream.png`;
export const IMG_DAINA_NEW_NO_BACKGROUND = `${BASE}/Daina-new-no-background.png`;
export const IMG_DAINA_NEW = `${BASE}/Daina-new.png`;
export const IMG_GOTS_HANG_TAG = `${BASE}/GOTS-Hang-Tag.png`;
export const IMG_HOME_WALLPAPER_NEW = `${BASE}/Home-Wallpaper-New.png`;
export const IMG_HOODIE_BEIGE_RED_1 = `${BASE}/Hoodie-Beige-Red-1.png`;
export const IMG_HOODIE_BLACK_01 = `${BASE}/Hoodie-Black-01.png`;
export const IMG_HOODIE_BLACK_RED_1 = `${BASE}/Hoodie-Black-Red-1.png`;
export const IMG_HOODIE_BLACK_RED_MAIN = `${BASE}/Hoodie-Black-Red-Main.png`;
export const IMG_HOODIE_BLACK_RED_WALLPAPER = `${BASE}/Hoodie-Black-Red-Wallpaper.png`;
export const IMG_HOODIE_BLUE_01 = `${BASE}/Hoodie-Blue-01.png`;
export const IMG_HOODIE_BLUE_2 = `${BASE}/Hoodie-Blue-2.png`;
export const IMG_HOODIE_BLUE_SMALL_LOGO_01 = `${BASE}/Hoodie-Blue-Small-Logo-01.png`;
export const IMG_HOODIE_PINK_01 = `${BASE}/Hoodie-Pink-01.png`;
export const IMG_HOODIE_PINK_3 = `${BASE}/Hoodie-Pink-3.png`;
export const IMG_HOODIE_PINK_BACKGROUND = `${BASE}/Hoodie-Pink-Background.jpeg`;
export const IMG_HOODIE_SIZE_CHART = `${BASE}/Hoodie-Size-Chart.png`;
export const IMG_HOODIE_WHITE_01 = `${BASE}/Hoodie-White-01.png`;
export const IMG_HOODIE_WHITE_1 = `${BASE}/Hoodie-White-1.png`;
export const IMG_HOODIE_WHITE_RED_1 = `${BASE}/Hoodie-White-Red-1.png`;
export const IMG_ICON_UNISEX_38X = `${BASE}/ICON_Unisex_38x.jpeg`;
export const IMG_LOGO_BLACK = `${BASE}/Logo-Black.png`;
export const IMG_LOGO_NEW = `${BASE}/Logo-New.png`;
export const IMG_LOGO = `${BASE}/Logo.PNG`;
export const IMG_ORGANIC_COTTON_IMAGE = `${BASE}/Organic-Cotton-Image.jpeg`;
export const IMG_OUR_MISSION_IMAGE = `${BASE}/Our-Mission-Image.jpeg`;
export const IMG_PILLOW1 = `${BASE}/Pillow1.jpeg`;
export const IMG_PILLOW2 = `${BASE}/Pillow2.jpeg`;
export const IMG_PILLOW3 = `${BASE}/Pillow3.jpeg`;
export const IMG_PILLOW4 = `${BASE}/Pillow4.jpeg`;
export const IMG_SIZE_CHART_IMAGE = `${BASE}/Size-Chart-Image.jpg`;
export const IMG_SIZE_ICON = `${BASE}/SizeIcon.png`;
export const IMG_SWEATSHIRT_BLACK_MAIN = `${BASE}/Sweatshirt-Black-Main.png`;
export const IMG_SWEATSHIRT_BLACK = `${BASE}/Sweatshirt-Black.png`;
export const IMG_WALLPAPER1 = `${BASE}/Wallpaper1.jpeg`;
export const IMG_BAUMWOLLE_ICON = `${BASE}/baumwolle-icon.png`;
export const IMG_DAINA_TSHIRT1 = `${BASE}/daina-tshirt1.png`;
export const IMG_DAINA_TSHIRT2 = `${BASE}/daina-tshirt2.png`;
export const IMG_DAINA_TSHIRT3 = `${BASE}/daina-tshirt3.png`;
export const IMG_DAINA_TSHIRT4 = `${BASE}/daina-tshirt4.png`;
export const IMG_DAINA_TSHIRT5 = `${BASE}/daina-tshirt5.png`;
export const IMG_EARRING_FROST1 = `${BASE}/earring-frost1.jpeg`;
export const IMG_EARRING_FROST2 = `${BASE}/earring-frost2.jpg`;
export const IMG_EARRING_FROST3 = `${BASE}/earring-frost3.jpg`;
export const IMG_EARRING_FROST4 = `${BASE}/earring-frost4.jpg`;
export const IMG_EARRING_FROST5 = `${BASE}/earring-frost5.jpg`;
export const IMG_EARRING_FROST6 = `${BASE}/earring-frost6.jpg`;
export const IMG_ICON_SHIPPING = `${BASE}/icon-shipping.jpeg`;
export const IMG_MASTER = `${BASE}/master.svg`;
export const IMG_NECKALCE_FEATHER1 = `${BASE}/neckalce-feather1.jpg`;
export const IMG_NECKALCE_FEATHER2 = `${BASE}/neckalce-feather2.jpg`;
export const IMG_NECKALCE_FEATHER3 = `${BASE}/neckalce-feather3.jpg`;
export const IMG_NECKALCE_FEATHER4 = `${BASE}/neckalce-feather4.jpg`;
export const IMG_NECKALCE_FEATHER5 = `${BASE}/neckalce-feather5.jpg`;
export const IMG_NECKALCE_FEATHER6_BG_REMOVED = `${BASE}/neckalce-feather6%20Background%20Removed.png`;
export const IMG_NECKALCE_FEATHER6 = `${BASE}/neckalce-feather6.jpg`;
export const IMG_PAYPAL_ICON = `${BASE}/paypal-icon.png`;
export const IMG_RUPAY = `${BASE}/rupay.svg`;
export const IMG_SILVER_EARRINGS = `${BASE}/silver-earrings.png`;
export const IMG_SILVER_NECKLACE = `${BASE}/silver-necklace.png`;
export const IMG_SPULE = `${BASE}/spule.jpeg`;
export const IMG_UPI = `${BASE}/upi.svg`;
export const IMG_VISA = `${BASE}/visa.svg`;

export const IMG_TSHIRT_BEIGE_BACK = `${BASE}/DAINA%20T-Shirt%20Beige%20Back.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Black%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Black%20Girl.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Black.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_BOY = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Red%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1 = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Red%20Girl%201.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2 = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Red%20Girl%202.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3 = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Red%20Girl%203.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20Red.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE_BOY = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20White%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20White%20Girl.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE = `${BASE}/DAINA%20T-Shirt%20Beige%20Logo%20White.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT_LOGO_BOY = `${BASE}/DAINA%20T-Shirt%20Beige%20Without%20Logo%20Boy.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT_LOGO_GIRL = `${BASE}/DAINA%20T-Shirt%20Beige%20Without%20Logo%20Girl.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT = `${BASE}/DAINA%20T-Shirt%20Beige%20Without.png`;
export const IMG_DAINA_CAP_CREAM = `${BASE}/DAINA%20Cap%20Cream.png`;
export const IMG_DAINA_TERRY_SHORTS_RED = `${BASE}/DAINA%20Terry%20Shorts%20Red.png`; 
export const IMG_DAINA_CANVAS_TOTE_BLACK = `${BASE}/DAINA%20Canvas%20Tote%20Black.png`;
export const IMG_DAINA_HOME_PAGE_IMAGE_BEIGE = `${BASE}/DAINA%20Home%20Page%20Image%20Beige.png`;
export const IMG_DAINA_HOME_PAGE_IMAGE_BLACK = `${BASE}/DAINA%20Home%20Page%20Image%20Black.png`;
export const IMG_DAINA_HOME_PAGE_IMAGE_GRAY = `${BASE}/DAINA%20Home%20Page%20Image%20Gray.png`;
export const IMG_DAINA_HOME_PAGE_IMAGE_GRAY_MOBILE = `${BASE}/DAINA%20Home%20Page%20Image%20Gray%20Mobile.png`;
export const IMG_SIZE_CHART_TSHIRT = `${BASE}/Size%20Chart%20Tshirt.png`;

export const IMG_ETHNIC_LOOK_1 = "https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&w=1400&q=85";
export const IMG_ETHNIC_LOOK_2 = "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&w=1400&q=85";
export const IMG_ETHNIC_LOOK_3 = "https://images.unsplash.com/photo-1610189012906-4c3e46b6d0ea?auto=format&fit=crop&w=1400&q=85";
export const IMG_ETHNIC_LOOK_4 = "https://images.unsplash.com/photo-1583391733956-6c78276477e2?auto=format&fit=crop&w=1400&q=85";
export const IMG_HOME_PAGE_IMAGE = homePageImage;
export const IMG_ETHNIC_IMAGE_1 = ethnicWearImage1;
export const IMG_ETHNIC_IMAGE_2 = ethnicWearImage2;
export const IMG_ETHNIC_IMAGE_3 = ethnicWearImage3;
export const IMG_ETHNIC_IMAGE_4 = ethnicWearImage4;
export const IMG_FEATURED_EDITS_IMAGE_1 = featuredEditsImage1;
export const IMG_FEATURED_EDITS_IMAGE_2 = featuredEditsImage2;
export const IMG_SHOP_THE_LOOK_IMAGE = shopTheLookImage;
